import { defineStore } from "pinia";
export interface Notification {
  id: number;
  type:
    | "is-primary"
    | "is-link"
    | "is-info"
    | "is-success"
    | "is-warning"
    | "is-danger"
    | "is-default";
  message: string;
  duration: number;
  isActive: boolean;
  /** for code-based e2e assertions instead of string-matched copy. */
  errorCode?: string;
}
export interface NotificationState {
  notifications: Notification[];
}

let nextNotificationId = 0;

export const useNotificationStore = defineStore("notificationStore", {
  state: (): NotificationState => ({
    notifications: []
  }),
  actions: {
    addNotification(notification: Omit<Notification, "id" | "isActive">) {
      // Date.now() collided within the same millisecond, duplicating :key.
      nextNotificationId += 1;
      this.notifications.push({
        ...notification,
        id: nextNotificationId,
        isActive: true
      });
    },
    removeNotification(id: number) {
      this.notifications = this.notifications.filter(
        (notification) => notification.id !== id
      );
    }
  }
});
